import { APP_LANGUAGES } from '@/shared/config/languages';
import type { TranslationValue } from '@/shared/types';

/**
 * Normalizes a single translation field
 * Sets empty string for all languages if undefined
 */
export const normalizeTranslationValue = (translations: TranslationValue): TranslationValue => {
  const normalized: TranslationValue = {};
  APP_LANGUAGES.forEach((lang) => {
    normalized[lang.code] = translations[lang.code] ?? '';
  });
  return normalized;
};

/**
 * Normalizes all translation fields in a translations object
 * @example
 * normalizeTranslationFields({ name: { uz: 'test' }, description: { ru: 'desc' } })
 * // { name: { uz: 'test', ru: '', en: '' }, description: { uz: '', ru: 'desc', en: '' } }
 */
export const normalizeTranslationFields = <T extends Record<string, TranslationValue>>(translations: T): T => {
  const normalized = {} as T;

  Object.keys(translations).forEach((key) => {
    normalized[key as keyof T] = normalizeTranslationValue(translations[key]) as T[keyof T];
  });

  return normalized;
};
